<style scoped>
::v-deep .modal-window {
    border-radius: 2rem !important;
    @apply bg-primary !important;
}

.modal-content-wrapper {
    max-height: calc(100vh - 8rem);
}

ol {
    counter-reset: item;
}
ol > li {
    @apply my-2;
}
ol > li:before {
    content: counters(item, '.') '.\00a0 ';
    counter-increment: item;
}
</style>

<template>
    <div>
        <button @click="showModal = true" :class="btnClass">
            {{ $t(msg) }}
        </button>
        <modal
            type="custom"
            v-if="showModal"
            :showDismiss="true"
            class="modal-md text-white"
            @backdrop="showModal = false"
        >
            <div class="flex flex-col text-2xl modal-content-wrapper">
                <div class="self-center">介紹新會員</div>
                <div class="self-center w-auto text-base mt-4">
                    以下是貴公司的專屬連結 QR Code
                </div>
                <qrcode
                    v-if="referralUrl"
                    class="self-center w-60 h-60 mt-4"
                    :value="referralUrl"
                    :options="{
                        width: 200,
                        margin: 1.5
                    }"
                />
                <div class="self-center w-auto text-base mt-4">
                    請同事掃描 QR Code ，經「即刻登記」連結填妥會員資料，即可成為試吓啦會員！
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import modal from './modal.vue';
import qrcode from './qrcode.vue';

export default {
    components: {
        modal,
        qrcode
    },
    props: {
        msg: { type: String, default: '免費增加T-Coins' },
        btnClass: { type: String }
    },
    data() {
        return {
            showModal: false
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        cmpyEmailTknNum() {
            return this.user?.cmpyEmailTknNum;
        },
        referralUrl() {
            return this.cmpyEmailTknNum
                ? `${location.origin}${process.env.BASE_URL}previewProducts/${this.cmpyEmailTknNum}`
                : undefined;
        },
        enableReferralTcoinAward() {
            return this.$store.state.enableReferralTcoinAward;
        },
        enableBirthdayTcoinAward() {
            return this.$store.state.enableBirthdayTcoinAward;
        }
    }
};
</script>
